import { USER_ADD } from './Users.types';

export function userAdd(user: string) {
    return {
        type: USER_ADD,
        user, // action payload
    };
}
